import { ProductItem } from "./ProductItem";

interface ProductListProps {
  products: {
    id: number;
    title: string;
    price: number;
    image: string;
  }[];
}

export const ProductList = ({ products }: ProductListProps) => {
  return (
    <>
      {products.map((product) => (
        <ProductItem key={product.id} product={product} />
      ))}
    </>
  );
};
